"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const styling_1 = require("../../../styling");
const styles_1 = require("./styles");
const Close_1 = tslib_1.__importDefault(require("../../Icons/Close"));
const CarouselSlideRemoveButton = (0, mobx_react_lite_1.observer)(({ classes, onClick }) => {
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.carouselRemoveButtonStyles }, "carousel-remove-button");
    return (react_1.default.createElement("button", { type: "button", onClick: onClick, className: mergedClasses.root },
        react_1.default.createElement(Close_1.default, { weight: "normal", className: mergedClasses.icon })));
});
exports.default = CarouselSlideRemoveButton;
//# sourceMappingURL=index.js.map